<div class="d-flex flex-wrap gap-4">
  <app-mdb-button [text]="'VEHICLES.NEW_VEHICLE'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="openNewVehicleModal()" />
</div>

<app-vehicles-table />
